import json from './sprite.js';

export default {
    handle: 'SP_SPS10-Recess',
    label: 'es_SPS10-Recess_234684099',
    json,
};
